<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="设备编号" class="sj">
					<Input v-model="formValidate.operMacId" placeholder="请输入设备编号" disabled></Input>
				</FormItem>
				<FormItem label="负责人" class="sj"  prop="empId">
					<Select v-model="formValidate.empId" placeholder="请选择负责人" filterable>
						
						<Option v-for="(item,i) in emps" :key="item.id" :value="item.id">{{item.name}}-{{item.districtName}}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					operMacId: "",
					macCode: '',
					empId: ''
				},
				emps: [

				],
				ruleValidate: {
					empId: [{
						required: true,
						message: '请选择负责人！！！',
						trigger: 'blur'
					}],
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/mac/oper/update/emp',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					}
				})
				
				
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			ajax() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/page',
				    data: {page: 0,size: 1000},
					_this: _this,
					success: function(data) {
						_this.emps = data.empPage.content
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},

		created() { //请求数据
			this.formValidate.operMacId = this.$route.query.operMacId
			this.formValidate.empId = this.$route.query.operEmpId
			
			console.log(this.formValidate)
			this.ajax();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/mac/updateEmp.vue